import '@sapudex/web-components/dist/Avatar.js';
import '@sapudex/web-components/dist/Tile.js';
import { ul } from '../../scripts/dom-builder.js';
import ffetch from '../../scripts/ffetch.js';
import { isArticle } from '../../scripts/utils/article-utils.js';
import {
  buildCardDisplayProfile,
  fetchProfiles,
  lookupProfiles,
} from '../../scripts/utils/author-utils.js';
import moveInstrumentation from '../../scripts/utils/editor-support-utils.js';
import {
  getIndexPath,
  INDEX_ARTICLES,
} from '../../scripts/utils/index-utils.js';
import { localisePath } from '../../scripts/utils/link-utils.js';
import { applyLayout } from '../../scripts/utils/list-layout-utils.js';
import getPageAdditionalElements from '../../scripts/utils/smart-crop-utils/get-page-additional-elements.js';
import { fetchTagList } from '../../scripts/utils/tags-utils.js';
import getI18next from '../../scripts/utils/translations/get-translations.js';
import { infoTypes } from './constants.js';
import getFeatureArticleCard from './utils/get-feature-article-card.js';
import getPropValue from './utils/get-prop-value.js';
import matchArticlePath from './utils/match-article-path.js';
import sortArticles from './utils/sort-articles.js';

function getArticle({
  articleData,
  tags,
  infoOption,
  showAuthor,
  i18next,
  authorIndex,
  horizontal,
}) {
  const author = (async () => {
    const getAuthorIndex = () => authorIndex;
    const authors = lookupProfiles(articleData.author, await getAuthorIndex());
    return showAuthor && buildCardDisplayProfile(authors);
  })();

  return getFeatureArticleCard({
    articleData,
    author,
    tags,
    i18next,
    horizontal,
    infoType: infoOption,
  });
}

async function getArticles() {
  const dataSource = getIndexPath(INDEX_ARTICLES);
  const cacheKey = 'sapContentHubArticles';

  return ffetch(dataSource, cacheKey).all();
}

export default async function decorate(block) {
  const { isSideNav } = getPageAdditionalElements();

  if (isArticle() || isSideNav) {
    block.classList.add('stacked');
  }

  const rows = Array.from(block.children);
  const links = rows
    .map((row, index) => {
      const link = row.querySelector('a');
      const path = link ? new URL(link.href).pathname : null;
      return path
        ? {
            index,
            link: localisePath(path),
          }
        : null;
    })
    .filter((link) => link !== null);

  if (rows.length > 0) {
    const authorIndex = fetchProfiles();
    const [i18next, tags, articlesIndex] = await Promise.all([
      getI18next(),
      fetchTagList(),
      getArticles(),
    ]);

    const articles = articlesIndex.filter((article) =>
      links.some((link) => matchArticlePath(article.path, link.link)),
    );

    const horizontal =
      block.classList.contains('horizontal') || articles.length === 1;

    const infoOption =
      getPropValue(block, 'info') || infoTypes.AUTHOR_AND_UPDATED;

    const sortOption = getPropValue(block, 'sortOption');

    sortArticles(articles, links, sortOption, infoOption);

    const showAuthor = infoOption.toLowerCase().includes('author');

    const cardList = ul();
    // eslint-disable-next-line no-inner-declarations

    articles.forEach((article) => {
      const card = getArticle({
        articleData: article,
        tags,
        infoOption,
        showAuthor,
        i18next,
        authorIndex,
        horizontal,
      });
      const rowIndex = links.find((link) =>
        matchArticlePath(article.path, link.link),
      )?.index;
      moveInstrumentation(rows[rowIndex], card);
      cardList.append(card);
    });
    // We cannot tell the difference between an empty config row and an empty featured article item
    // based on content.
    // We need to check the UE specific properties on the elements and remove only those which are
    // not featured article items.
    // These attributes will not be present on the published page, however, we would want to remove
    // empty featured articles in that case as well. They only matter for the UE editor experience.
    rows.forEach((row) => {
      if (row.getAttribute('data-aue-model') !== 'featured-article') {
        row.remove();
      }
    });
    applyLayout(cardList, cardList);
    block.append(cardList);
  }
}
